import { useState, useEffect } from 'react';
// import axios from 'axios';

function MFacts(props) {
    const [factsData, setFactsData] = useState([]);
    /*
    function sendToLLM(message) {
        try {
            fetch('https://api.together.ai/v1/chat/completions', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer 26c44f5adc59521c95eaa161ecc13606dd4e727babd3a4b7f60f6c6b9c76081e', // ⚠️ Exposed in browser
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    model: 'meta-llama/Meta-Llama-3-70B-Instruct-Turbo',
                    messages: [{ role: 'user', content: `
Extract a list of people from ${leadTld}
For each person, return: Full Name, Role/Title, Phone Number (if found),, Email (if found), LinkedIn URL (if found)
Output format: JSON array of objects.
                        ` }],
                })
            })
            .then(res => res.json())
            .then(data => setFactsData(data??{}));
        } catch (e) {
            console.log(e)
        }
    }
    */
    useEffect(() => {
        props.urd(true);

        if (props.data && (props.data.length > 0)) {
            const id = (props.mode === 'leads') ? props.data[0].id : props.data[0].leadid;
            const name = props.data[0].trimmedname; 
            const tld = props.data[0].tld; 
            setFactsData({id, name, tld})
            // sendToLLM(tld);
        }

        props.urd(false);
    }, [props.data])

    return (
    <div className="h-100 d-flex flex-column overflow-auto">
        <h1>Facts</h1>
        <div>{JSON.stringify(factsData)}</div>
    </div>
    )
}

export default MFacts;